import React from 'react';
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import propTypes from 'prop-types';
import TransactionTableHead from './TransactionTableHead';

function TransactionsSkeleton({ showTitle = true }) {
  const handleSelectAll = () => {};

  return (
    <Box>
      {showTitle && (
        <Stack direction="row" alignItems="center" mb={3}>
          <Typography variant="pageTitle">Banking ?&apos;s</Typography>
          <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
        </Stack>
      )}

      <Paper>
        <Toolbar
          className="border-bottom"
          sx={{
            px: 0,
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, width: '50%' }} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              justifyContent: { xs: 'space-between', sm: 'space-between', md: 'flex-end' },
              mb: { xs: 2, sm: 2, lg: 0 },
              alignItems: 'center',
              width: { lg: 'auto', sm: '100%' },
            }}
          >
            <Skeleton variant="rectangular" width={200} height={40} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rounded" width={130} height={36} />
          </Box>
        </Toolbar>

        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ tableLayout: 'fixed', minWidth: 650 }}>
            <TransactionTableHead handleSelectAll={handleSelectAll} disabled checked={false} />
            <TableBody>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Stack direction="row" alignItems="center">
                      <Skeleton animation="wave" variant="rectangular" width={20} height={20} sx={{ mr: 1 }} />
                      <Skeleton animation="wave" variant="text" width="70%" height={24} />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="80%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="60%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="rectangular" width="100%" height={100} sx={{ borderRadius: 1 }} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 2 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="rounded" width={60} height={32} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

TransactionsSkeleton.propTypes = {
  showTitle: propTypes.bool,
};

export default TransactionsSkeleton;
